import { useEffect, useState } from 'react';

import throttle from '../utils/helpers/throttle';

export const useScroll = () => {
  if (typeof document === 'undefined')
    return { currentDistance: 0, direction: '', distance: 0, posY: 0 };
  const [scroll, setScroll] = useState({
    currentDistance: 0,
    direction: '',
    distance: 0,
    posY: document.body.getBoundingClientRect().top,
  });

  const listener = () => {
    setScroll((prevState) => {
      const currentScrollPosition = document.body.getBoundingClientRect().top;
      const currentDirection =
        prevState.posY < currentScrollPosition ? 'up' : 'down';
      const currentDistance = Math.abs(prevState.posY - currentScrollPosition);
      return {
        currentDistance,
        direction: currentDirection,
        distance:
          currentDirection === prevState.direction
            ? prevState.distance + currentDistance
            : 0,
        posY: currentScrollPosition,
      };
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(listener, 50));
    return () => {
      window.removeEventListener('scroll', throttle(listener, 50));
    };
  }, []);

  // when we change page, we reset the posY to 0 to avoid menu flicking when sticky
  useEffect(() => {
    setScroll((prevState) => {
      return { ...prevState, posY: 0 };
    });
  }, [window.location.href]);

  return scroll;
};
